import { render } from "./UpdateVirusVersion.vue?vue&type=template&id=fb5ad4a8&scoped=true&ts=true"
import script from "./UpdateVirusVersion.vue?vue&type=script&lang=ts"
export * from "./UpdateVirusVersion.vue?vue&type=script&lang=ts"

import "./UpdateVirusVersion.vue?vue&type=style&index=0&id=fb5ad4a8&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb5ad4a8"]])

export default __exports__